export default __webpack_public_path__ + "static/media/7E9AB2CE-552E-4BAE-9C39-60F6E0E3F451_1_105_c.d4081269.jpeg";